import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'fz-game-card-description',
  templateUrl: './description.component.html',
  styleUrls: ['./description.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GameCardDescriptionComponent {}
